import { EGarageStatus, NonEmptyArray } from '../../../../../../../packages/JsonQuery';
import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectGarageStatusFilter } from 'shared/selectors/advancedFilters';
import { AdvancedFilterRow, MultiSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';

export const GarageStatusContainer: FC = () => {
  const { label, value, options } = useSelector(selectGarageStatusFilter);

  const onChange = useFilterChangeCallback();

  const handleGarageStatusChange = useCallback(
    (newValue: NonEmptyArray<EGarageStatus> | null) => {
      onChange({ action: 'setGarageStatus', arguments: [newValue] });
    },
    [onChange],
  );

  return (
    <AdvancedFilterRow label={label}>
      <MultiSelectionAdvancedFilter value={value} options={options} onFilterChange={handleGarageStatusChange} />
    </AdvancedFilterRow>
  );
};
